export default __webpack_public_path__ + "static/media/IMG_2191.04eb3903.jpg";